import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchPortfolio, type PortfolioQuery } from '@/services/api/portfolio.api';

/**
 * Cross-property portfolio rollup for the current tenant (Hotel Groups F2).
 * GET /dashboard/portfolio — per-currency buckets + a paginated drill-down.
 * `enabled` lets callers hold the query until a valid date range exists.
 */
export function usePortfolio(query: PortfolioQuery, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['dashboard', 'portfolio', query],
    queryFn: () => fetchPortfolio(query),
    enabled: options?.enabled ?? true,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
